(() => {
  function initHero(root) {
    if (root.dataset.zeReady) return;
    root.dataset.zeReady = 'true';
    const tabs = [...root.querySelectorAll('[data-ze-tab]')];
    const panels = [...root.querySelectorAll('[data-ze-slide]')];
    const pause = root.querySelector('[data-ze-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, paused = reduced.matches, focus = false;
    const show = next => {
      index = (next + tabs.length) % tabs.length;
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
    };
    const updatePause = () => { pause.textContent = paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label', paused ? pause.dataset.play : pause.dataset.pause); };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => { show(i); paused = true; updatePause(); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = index + 1;
        if (event.key === 'ArrowLeft') next = index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); show(next); tabs[index].focus(); paused = true; updatePause();
      });
    });
    pause.addEventListener('click', () => { paused = !paused; updatePause(); });
    root.addEventListener('focusin', () => { focus = true; });
    root.addEventListener('focusout', event => { focus = root.contains(event.relatedTarget); });
    root.addEventListener('mouseenter', () => { focus = true; });
    root.addEventListener('mouseleave', () => { focus = root.contains(document.activeElement); });
    updatePause();
    const timer = setInterval(() => { if (!root.isConnected) { clearInterval(timer); return; } if (!paused && !focus && !document.hidden) show(index + 1); }, 5200);
  }
  const init = () => document.querySelectorAll('[data-ze-hero]').forEach(initHero);
  init(); document.addEventListener('shopify:section:load', init);
})();
